import { render, staticRenderFns } from "./FireComp.vue?vue&type=template&id=24db9e28&scoped=true&"
import script from "./FireComp.vue?vue&type=script&lang=js&"
export * from "./FireComp.vue?vue&type=script&lang=js&"
import style0 from "./FireComp.vue?vue&type=style&index=0&id=24db9e28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db9e28",
  null
  
)

export default component.exports